import React from 'react'



import ReactWhatsapp from "react-whatsapp";



import chockernecklace from "../images/21.810gm new chocker.jpg";
import choker13_160gm from "../images/13.160gm.jpg";
import Choker14_470gm from "../images/14.470gm.jpg";
import choker15_410gm from "../images/15.410gm.jpg";

import necklace15_840gm from "../images/15.840gm.jpg";
import choker15_900gm from "../images/15.900gm.jpg";
import choker16_770gm from "../images/16.770gm.jpg";
import necklace17_520gm from "../images/17.520gm.jpg";

import cholker18_780gm from "../images/18.780gm.jpg";
import Choker19_180gm from "../images/19.180gm.jpg";
import Choker20_440gm from "../images/20.440gm.jpg";
import Choker20_820gm from "../images/20.820gm.jpg";

import choker20_850gm from "../images/20.850gm.jpg";
import Choker23_470gm from "../images/23.470gm.jpg";
import choker23_500gm from "../images/23.500gm.jpg";
import choker23_620gm from "../images/23.620gm.jpg";


import choker24_460gm from "../images/24.460gm.jpg";
import choker25_130gm from "../images/25.130gm.jpg";
import choker25_750gm from "../images/25.750gm.jpg";
import choker26_900gm from "../images/26.900gm.jpg";


import choker26_910gm from "../images/26.910gm.jpg";
import choker32_020gm from "../images/32.020gm.jpg";
import choker42_860gm from "../images/42.860gm.jpg";
import choker42_570gm from "../images/43.570gm.jpg"

import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'





function ChokerNecklace() {
    return (
        <div>

         
            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={chockernecklace} className="card-img-top" alt="chockernecklace" />

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Choker Necklace </h5>
                                                <p className="card-text">Weight: 21.810gm</p>
                                                <p className="card-text">ID No.</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={choker13_160gm} className="card-img-top" alt="Choker Necklace" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Choker Necklace</h5>
                                                <p className="card-text">Weight: 13.160gm</p>
                                                <p className="card-text">ID No..</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={Choker14_470gm} className="card-img-top" alt="Choker Necklace"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Choker Necklace </h5>
                                                <p className="card-text">Weight: 14.470gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={choker15_410gm} className="card-img-top" alt="Choker Necklace"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Choker Necklace                                   </h5>
                                                <p className="card-text">Weight: 15.410gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                               
                                    <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img id="myimage" src={necklace15_840gm} className="card-img-top" alt="Choker Necklace"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Choker Necklace </h5>
                                                <p className="card-text">Weight: 15.840gm</p>
                                                <p className="card-text">ID No.</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={choker15_900gm} className="card-img-top" alt="Choker Necklace" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Choker Necklace</h5>
                                                <p className="card-text">Weight: 15.900gm</p>
                                                <p className="card-text">ID No..</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={choker16_770gm} className="card-img-top" alt="Choker Necklace" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Choker Necklace</h5>
                                                <p className="card-text">Weight: 16.770gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={necklace17_520gm} className="card-img-top" alt="Choker Necklace" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Choker Necklace</h5>
                                                <p className="card-text">Weight: 17.520gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img id="myimage" src={cholker18_780gm} className="card-img-top" alt="Choker Necklace" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Choker Necklace </h5>
                                                <p className="card-text">Weight: 18.780gm</p>
                                                <p className="card-text">ID No.</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="col-md-6  mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={Choker19_180gm} className="card-img-top" alt="Choker Necklace" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Choker Necklace</h5>
                                            <p className="card-text">Weight: 19.180gm</p>
                                            <p className="card-text">ID No..</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={Choker20_440gm} className="card-img-top" alt="Choker Necklace" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1"></h5>Choker Necklace
                                            <p className="card-text">Weight: 20.440gm</p>
                                            <p className="card-text">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={Choker20_820gm} className="card-img-top" alt="Choker Necklace" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1" >Choker Necklace</h5>
                                            <p className="card-text">Weight: 20.820gm</p>
                                            <p className="card-text">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img id="myimage" src={choker20_850gm} className="card-img-top" alt="Choker Necklace" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Choker Necklace </h5>
                                            <p className="card-text">Weight: 20.850gm</p>
                                            <p className="card-text">ID No.</p>

                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>


                                        </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="col-md-6  mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={Choker23_470gm} className="card-img-top" alt="Choker Necklace"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Choker Necklace</h5>
                                            <p className="card-text">Weight: 23.470gm</p>
                                            <p className="card-text">ID No..</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                    </div>
                                    </div>


                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={choker23_500gm} className="card-img-top" alt="Choker Necklace"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1">Choker Necklace</h5>
                                            <p className="card-text">Weight: 23.500gm</p>
                                            <p className="card-text">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={choker23_620gm} className="card-img-top" alt="Choker Necklace" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1" >Choker Necklace</h5>
                                            <p className="card-text">Weight: 23.620gm</p>
                                            <p className="card-text">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img id="myimage" src={choker24_460gm} className="card-img-top" alt="Choker Necklace" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Choker Necklace </h5>
                                            <p className="card-text">Weight: 24.460gm</p>
                                            <p className="card-text">ID No.</p>

                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>


                                        </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="col-md-6  mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={choker25_130gm} className="card-img-top" alt="Choker Necklace" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Choker Necklace</h5>
                                            <p className="card-text">Weight: 25.130gm</p>
                                            <p className="card-text">ID No..</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                    </div>
                                    </div>


                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={choker25_750gm} className="card-img-top" alt="Choker Necklace"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1">Choker Necklace</h5>
                                            <p className="card-text">Weight: 25.750gm</p>
                                            <p className="card-text">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={choker26_900gm} className="card-img-top" alt="Choker Necklace" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1" >Choker Necklace</h5>
                                            <p className="card-text">Weight: 26.900gm</p>
                                            <p className="card-text">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img id="myimage" src={choker26_910gm} className="card-img-top" alt="Choker Necklace" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Choker Necklace </h5>
                                            <p className="card-text">Weight: 26.910gm</p>
                                            <p className="card-text">ID No.</p>

                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>


                                        </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="col-md-6  mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={choker32_020gm} className="card-img-top" alt="Choker Necklace" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Choker Necklace</h5>
                                            <p className="card-text">Weight: 32.020gm</p>
                                            <p className="card-text">ID No..</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                    </div>
                                    </div>


                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={choker42_860gm} className="card-img-top" alt="Choker Necklace"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1">Choker Necklace</h5>
                                            <p className="card-text">Weight: 42.860gm</p>
                                            <p className="card-text">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={choker42_570gm} className="card-img-top" alt="Choker Necklace" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1" >Choker Necklace</h5>
                                            <p className="card-text">Weight: 43.570gm</p>
                                            <p className="card-text">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <br />

            <br />
        </div>
    )
}

export default ChokerNecklace